module.exports = __webpack_public_path__ + "static/media/icon_captured_check.ce062649.svg";